import React, { SyntheticEvent } from "react";
import { useParams } from "react-router-dom";
import { Menu, MenuItem } from "@mui/material";
import { dialogModel } from "../../../../common/component/dialog/dialog-model";
import { operationsService } from "../../../services/operations";
import { t } from "i18next";
import { notificationModel } from "../../../../common/component/notifications/notification-model";

interface ICancellationRequestMenuProps {
    anchorElement: HTMLElement;
    deliveryOrderId: number;
    refreshSearchList: () => void;
    onCancellationRequestMenuClose: () => void;
}

export const CancellationRequestMenu = (props: ICancellationRequestMenuProps) => {
    const params = useParams();

    const executeConfirmation = (event: SyntheticEvent) => {
        if (!props.deliveryOrderId) {
            return;
        }

        const deliveryOrderId = props.deliveryOrderId;
        dialogModel.confirmBox(
            t("deliveryOrderCancellation.action.title"),
            t("deliveryOrderCancellation.action.description", {deliveryOrderId: props.deliveryOrderId}),
            async () => await confirmCancellationAction(params.operationCode!, Number(params.batchId), deliveryOrderId),
        );

        closeMenuWithNoPropagation(event);
    };

    const confirmCancellationAction = async (operationCode: string, batchId: number, deliveryOrderId: number) => {
        try {
            await operationsService.confirmCancellationRequest(operationCode,
                batchId,
                deliveryOrderId);

            await props.refreshSearchList();
            notificationModel.addSuccessMessage(t("deliveryOrderCancellation.action.successMessage"));
        } catch (error) {
            notificationModel.addErrorMessage(t("deliveryOrderCancellation.action.failedMessage"));
        }
    };

    const closeMenuWithNoPropagation = (event: SyntheticEvent) => {
        props.onCancellationRequestMenuClose();
        event.stopPropagation();
    };

    return <Menu
        id="order-cancellation-request-action-menu"
        anchorEl={props.anchorElement}
        open={props.anchorElement !== undefined}
        onClose={(event: SyntheticEvent) => closeMenuWithNoPropagation(event)}
        data-testid={"order-cancellation-request-action-menu"}
    >
        <MenuItem onClick={event => executeConfirmation(event)}
                  data-testid="order-cancellation-request-action-confirm">
            {t("deliveryOrderCancellation.action.title")}
        </MenuItem>
    </Menu>;
};
